"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgileTrialSuspendedCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const commands_1 = require("../../_shared/commands");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const __1 = require("../..");
const TITLE = "Your trial of AgilePolly has ended";
const MESSAGE = "Please upgrade to a paid subscription to continue using standup features";
const DISABLE_BUTTON_LABEL = "Disable All Standups";
const AgileTrialSuspendedCard = (webDomain, hasActiveSchedules, gracePeriodDurationDays, subscriptionId, feedbackSurveyId) => {
    const card = CardHelper_1.CardHelper.newCard();
    card.addItem((0, __1.SubscribeBlock)("agile", TITLE, MESSAGE, webDomain, "agile-trial-suspended-dm"));
    if (hasActiveSchedules) {
        const DISABLE_MESSAGE = `You have active standups which will continue to be sent for the next ${gracePeriodDurationDays} days. Click "${DISABLE_BUTTON_LABEL}" to disable them now.`;
        card.addItem(CardHelper_1.CardHelper.create(adaptivecards_1.TextBlock, {
            color: adaptivecards_1.TextColor.Attention,
            horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
            spacing: adaptivecards_1.Spacing.Large,
            size: adaptivecards_1.TextSize.Medium,
            text: DISABLE_MESSAGE,
            wrap: true,
        }));
    }
    if (feedbackSurveyId) {
        card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            title: "Give Feedback",
            isPrimary: true,
            data: (0, commands_1.takingStartCommand)(feedbackSurveyId).toTaskFetchCommand(),
        }));
    }
    card.addAction((0, commands_1.DeleteCardAction)());
    if (hasActiveSchedules) {
        card.addAction(CardHelper_1.CardHelper.create(adaptivecards_1.SubmitAction, {
            title: DISABLE_BUTTON_LABEL,
            data: (0, commands_1.scheduleDisableAllForSubscriptionCommand)(subscriptionId).toTaskFetchCommand(),
        }));
    }
    return card;
};
exports.AgileTrialSuspendedCard = AgileTrialSuspendedCard;
//# sourceMappingURL=AgileTrialSuspendedCard.js.map